import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1731716034156669';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-cream text-slate-900 selection:bg-gold/30 selection:text-forest-dark" data-id="element-0" data-mp="3dmfn1j59sjkv">
      <main data-id="element-1" data-mp="nvasltl5rjh6">
        <Hero data-id="element-2" data-mp="nxwwnj8ubgun" />
        <TestimonialsStrip data-id="element-3" data-mp="sunf2d84aoj8" />
        <PainPoints data-id="element-4" data-mp="stubfl4ggf5b" />
        <SolutionReveal data-id="element-5" data-mp="st2gmciomlg3" />
        <TomosSection data-id="element-6" data-mp="swq8z8ce51t8" />
        <BonusSection data-id="element-7" data-mp="3686tkdjumw2" />
        <PricingSection data-id="element-8" data-mp="35ovwnmbgyrj" />
        <ExtendedTestimonials data-id="element-9" data-mp="34x2njg6zd4f" />
        <Guarantee data-id="element-10" data-mp="38b2ol1dva8p" />
        <FAQ data-id="element-11" data-mp="3udawu8hnin4p" />
        <FinalCTA data-id="element-12" data-mp="3udkmtw2p4uae" />
      </main>
      <Footer data-id="element-13" data-mp="3ucjc5sple9t7" />
      <PurchaseNotifications data-id="element-14" data-mp="3uevqzx020421" />
    </div>;
}